import { productIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { BillOfMaterials } from "./bill-of-materials-types";

export const getBillOfMaterialsByOutputProducts = {
  name: "getBillOfMaterialsByOutputProducts" as const,
  input: z.object({ productIds: z.array(productIdFormat.schema) }),
  output: z.object({ billOfMaterials: z.array(BillOfMaterials) }),
};
